// NPM Modules
import React from 'react';

// Modules
import '../styles/recipedia.css';

const Home = React.createClass({

  // Base URL of alexa.recipedia.com redirects to www.recipedia.com
  componentWillMount() {
    location.replace("http://www.recipedia.com/");
  },

  render() {
    return (
      <div className="main">
        <div id="top" className="landing-main">
          <div className=" container text-vertical-center">
          </div>
        </div>
      </div>
    );
  }
});

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js